import { API_URL } from '../config';
import axios from 'axios';

export function captureReferral() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref) {
    localStorage.setItem('affiliate_code', ref);
    axios.post(`${API_URL}/affiliate/track-click`, {
      affiliate_code: ref,
      page: window.location.pathname
    }).catch(() => {});
  }
}

export function getAffiliateCode() {
  return localStorage.getItem('affiliate_code') || '';
}

export async function trackConversion(amount, product = 'ghostwriter') {
  const code = getAffiliateCode();
  if (!code) return;
  try {
    await axios.post(`${API_URL}/affiliate/track-conversion`, {
      affiliate_code: code, amount, product
    });
  } catch (e) { /* silent */ }
}
